import { environment } from '../../environments/environment';

export enum PermissionTypes {
    PAGE = 1,
    CONTROL = 2
}

export enum CoCauToChucLoai {
    Truong = 1,
    KhoaPhongBan = 2,
    BoMon = 3,
    Khac = 4
}

export class PsConstants {
    // public static MaxFileSize = 1000000000;

    // public static Date_Format = 'dd/MM/yyyy';
    // public static DateTime_Format = 'dd/MM/yyyy hh:mm:ss';

    // public static ApiLog = `${environment.apiDomain.logEndpoint}`;
    // public static ApiQLNS = `${environment.apiDomain.qlnsEndpoint}`;
    // public static ApiNCKH = environment.apiDomain.nckhEndpoint;
    // public static remoteStorageOrigin = environment.apiDomain.remoteStorageOrigin;
    // public static LoginUrl = `${environment.apiDomain.remoteStorageOrigin}/dang-nhap`;
    // public static AuthenticationServiceEndpoint = `${environment.apiDomain.authenticationEndpoint}`;
    // public static AuthorizationServiceEndpoint = `${environment.apiDomain.authorizationEndpoint}`;
    // public static NotificationServiceEndpoint = `${environment.apiDomain.notificationEndpoint}`;
    // public static CategoryServiceEndpoint = `${environment.apiDomain.danhmucEndpoint}`;
    // public static NavigationServiceEndpoint = `${environment.apiDomain.navigationEndpoint}`;
    // public static DanhMucServiceEndpoint = `${environment.apiDomain.danhmucEndpoint}`;

    // public static LogSessionKey = 'log_session_key';
    // public static DefaultImageUrl = '';

    // public static ApiDashboard = `${environment.apiDomain.dashboardEndpoint}`;
    // // FsFileUpload
    // public static ApiFsFile = `${environment.apiDomain.fileEndpoint}/FsFiles`;
    // public static ApiFsFolder = `${environment.apiDomain.fileEndpoint}/FsFolders`;
    // public static FsAppFolder = 'dapfood';
    // public static GoogleViewOnline = 'https://docs.google.com/viewerng/viewer?embedded=false&url=';
    // public static AllowedUrls = [environment.apiDomain.gateway, environment.apiDomain.gatewayLocal];
}
